import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../helpers';
import { ScriptLoaderService } from '../../_services/script-loader.service';


@Component({
  selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
  templateUrl: "./eacds.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class EACDSComponent implements OnInit {


  constructor() {

  }
  ngOnInit() {

  }

}
